function Radio(props) {
    const errorExists = props.inputErrors?.includes(props.id);
    const errorId = errorExists ? `${props.id}Error` : undefined;

    return (
            <div className={'rtds-input rtds-input-field ' + (props.classDiv ?? '')}>
                <div className={(props.classDivInput ?? 'rtds-flex rtds-gap-2 rtds-items-center') + (props.inputErrors?.includes(props.id) ? ' has-error' : '')}>
                    <input
                    
                        required={!!props.required}
                        id={`${props.id}`} // ID univoco
                        name={props.id} // Nome univoco per il gruppo radio
                        className={props.classInput + (props.disabled ? ' rtds-background-02' : '')}
                        type='radio'
                        aria-describedby={errorId}
                        onChange={(event) => props.onChange(event)}
                        aria-invalid={errorExists}
                        checked={props.checked}
                        defaultChecked={props.defaultChecked}
                        minLength={props.minLength}
                        maxLength={props.maxLength}
                        disabled={props.disabled}
                        pattern={props.pattern}
                        hidden={props.hidden}
                        title={props.title}
                        value={props.value}
                    />
                    <label htmlFor={`${props.id}`} className='rtds-input-radio__label '>
                        {props.label}{props.required ? ' ' : ''}
                    </label>
                    
                </div>
                {errorExists && (
                <span className='rtds-input-field__hint' hidden={!props.inputErrors?.includes(props.id)}>
                    <span
                        className='rtds-input-field__error'
                        id={props.id + 'Error'}
                        aria-live='assertive'
                    >
                        {props.errorMessage ?? 'Campo obbligatorio'}
                    </span>
                </span>
                  )}
            </div>
    );
}

export default Radio;
